/// <reference path="../../common/common/common.ts" />
/// <reference path="../../../teva/sortable/sortable.ts" />

namespace OfficeGuy.Apps {
    export class RoutePlanning {
        static UpdateAddress(Link, CustomerID, PropertyID_NavigationAddress, AddressSelectID) {
            var AddressID = <string>$('#' + AddressSelectID).val();
            if (AddressID == null || AddressID.length == 0)
                return;

            Common.AjaxRequest({
                URL: "/crm/updatepropertynotification/",
                Data:
                {
                    EntityID: CustomerID,
                    Values: [
                        {
                            PropertyID: PropertyID_NavigationAddress,
                            Value: AddressID,
                        }
                    ]
                },
                SuccessMethod: function (Data) {
                    $(Link).attr("disabled", "disabled");
                    $('#' + AddressSelectID).attr("disabled", "disabled");
                },
                ShowLoading: false
            });
            return false;
        }

        static CalculateRoute(RouteID, OptimizeOrder): void {
            Common.AjaxRequest({
                URL: "/routeplanning/calculaterouteajax/",
                Data: {
                    RouteID: RouteID,
                    OptimizeOrder: OptimizeOrder
                }
            });
        }

        static InitRoute(RouteID): void {
            Teva.Sortable.Enable($(".routepoints"), {
                ItemSelector: "> tr",
                HandleSelector: ".Handle",
                OnChange: function (MovedElement) {
                    Common.AjaxRequest({
                        URL: "/routeplanning/calculaterouteajax/",
                        Data: {
                            RouteID: RouteID,
                            RoutePointID: MovedElement.attr("data-routepointid"),
                            NewIndex: MovedElement.index(),
                            OptimizeOrder: false
                        }
                    });
                }
            });

            $(".og-routeplanning-point-update").on("click", function () {
                var PointID = $(this).closest("tr").data("routepointid");
                var PropertyID = $(this).closest("table").data("statuspropertyid");
                var Status = $(this).data("status");
                var DatePropertyID = $(this).closest("table").data("datepropertyid");
                Common.AjaxRequest({
                    URL: "/crm/updatepropertynotification/",
                    Data: {
                        EntityID: PointID,
                        Values: [
                            {
                                PropertyID: PropertyID,
                                Value: Status
                            },
                            {
                                PropertyID: DatePropertyID,
                                Value: new Date()
                            }],
                        Refresh: true
                    },
                    ShowLoading: true
                });
                return false;
            });
        }

        static InitSendDailySMS() {
            $(".og-routeplanning-dailysms-recipients thead input[type=checkbox]").prop("checked", $(".og-routeplanning-dailysms-recipients tbody input[type=checkbox]:not(:checked)").length == 0).on("change", function () {
                $(".og-routeplanning-dailysms-recipients tbody input[type=checkbox]").prop("checked", $(this).prop("checked"));
            });
            $(".og-routeplanning-dailysms-recipients tbody input[type=checkbox]").on("change", function () {
                $(".og-routeplanning-dailysms-recipients thead input[type=checkbox]").prop("checked", $(".og-routeplanning-dailysms-recipients tbody input[type=checkbox]:not(:checked)").length == 0);
            });
        }
    }
}